<template>
  <div class="statistics-container">
    <div class="page-header">
      <div class="header-title">
        <div class="title-mark"></div>

        <span>产品明细销售统计</span>
      </div>
    </div>

    <div class="search-area">
      <el-date-picker
        v-model="dateRange"
        type="daterange"
        range-separator="至"
        start-placeholder="结算开始日期"
        end-placeholder="结算结束日期"
        value-format="yyyy-MM-dd"
        class="search-input date-picker"
      ></el-date-picker>

      <el-select
        v-model="selectedContractNames"
        multiple
        filterable
        placeholder="合同名称（多选）"
        class="search-input select-multi"
        clearable
      >
        <el-option
          v-for="item in contractNameOptions"
          :key="item"
          :label="item"
          :value="item"
        ></el-option>
      </el-select>

      <el-input
        v-model="productNameKeyword"
        clearable
        placeholder="产品名称（模糊）"
        class="search-input product-name-input"
      ></el-input>

      <el-button type="primary" @click="handleSearch" icon="el-icon-search"
        >搜索</el-button
      >

      <el-button @click="handleReset" icon="el-icon-refresh">重置</el-button>

      <el-button
        v-permission="'product:settlement-sales-statistics:export'"
        type="warning"
        @click="handleExport"
        icon="el-icon-download"
        :loading="exportLoading"
        >导出</el-button
      >
    </div>

    <div class="table-area">
      <el-table
        :data="tableData"
        border
        stripe
        show-summary
        :summary-method="summaryMethod"
        style="width: 100%"
        v-loading="loading"
        :header-cell-style="{ background: '#f5f7fa', color: '#606266' }"
      >
        <el-table-column
          prop="contractName"
          label="合同名称"
          min-width="160"
          align="center"
          show-overflow-tooltip
        ></el-table-column>

        <el-table-column
          prop="productName"
          label="产品名称"
          min-width="140"
          align="center"
          show-overflow-tooltip
        ></el-table-column>

        <el-table-column
          prop="unit"
          label="单位"
          width="100"
          align="center"
          show-overflow-tooltip
        ></el-table-column>

        <el-table-column
          prop="salesQuantity"
          label="销售数量"
          width="120"
          align="center"
        >
          <template slot-scope="scope">
            {{ formatQuantity(scope.row.salesQuantity) }}
          </template>
        </el-table-column>

        <el-table-column
          prop="salesAmount"
          label="销售金额"
          width="130"
          align="center"
        >
          <template slot-scope="scope">
            {{ formatAmount(scope.row.salesAmount) }}
          </template>
        </el-table-column>

        <el-table-column
          prop="demandUnitNames"
          label="需求方"
          min-width="140"
          align="center"
          show-overflow-tooltip
        ></el-table-column>

        <el-table-column
          prop="projectNames"
          label="项目名称"
          min-width="160"
          align="center"
          show-overflow-tooltip
        ></el-table-column>

        <el-table-column label="操作" width="100" align="center" fixed="right">
          <template slot-scope="scope">
            <el-button
              type="text"
              size="small"
              @click="openDetailDialog(scope.row)"
              >明细</el-button
            >
          </template>
        </el-table-column>
      </el-table>

      <div class="pagination-container">
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="pagination.currentPage"
          :page-sizes="[10, 20, 30, 50]"
          :page-size="pagination.pageSize"
          layout="prev, pager, next, jumper, sizes, total"
          :total="pagination.total"
        >
        </el-pagination>
      </div>
    </div>

    <el-dialog
      :title="detailDialogTitle"
      :visible.sync="detailDialogVisible"
      width="920px"
      append-to-body
      @closed="onDetailDialogClosed"
    >
      <el-table
        :data="detailTableData"
        border
        stripe
        show-summary
        :summary-method="detailSummaryMethod"
        v-loading="detailLoading"
        max-height="420"
        :header-cell-style="{ background: '#f5f7fa', color: '#606266' }"
      >
        <el-table-column
          prop="specification"
          label="规格型号"
          min-width="120"
          align="center"
          show-overflow-tooltip
        ></el-table-column>

        <el-table-column
          prop="unit"
          label="单位"
          width="80"
          align="center"
        ></el-table-column>

        <el-table-column
          prop="salesQuantity"
          label="销售数量"
          width="120"
          align="center"
        >
          <template slot-scope="scope">
            {{ formatQuantity(scope.row.salesQuantity) }}
          </template>
        </el-table-column>

        <el-table-column
          prop="salesAmount"
          label="销售金额"
          width="130"
          align="center"
        >
          <template slot-scope="scope">
            {{ formatAmount(scope.row.salesAmount) }}
          </template>
        </el-table-column>

        <el-table-column
          prop="demandUnitNames"
          label="需求方"
          min-width="130"
          align="center"
          show-overflow-tooltip
        ></el-table-column>

        <el-table-column
          prop="projectNames"
          label="项目名称"
          min-width="140"
          align="center"
          show-overflow-tooltip
        ></el-table-column>
      </el-table>

      <span slot="footer" class="dialog-footer">
        <el-button @click="detailDialogVisible = false">关 闭</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import api from "@/api";

export default {
  name: "ProductSettlementSalesStatistics",

  data() {
    return {
      dateRange: [],

      selectedContractNames: [],

      productNameKeyword: "",

      contractNameOptions: [],

      loading: false,

      exportLoading: false,

      tableData: [],

      summaryTotals: null,

      pagination: {
        currentPage: 1,

        pageSize: 10,

        total: 0,
      },

      detailDialogVisible: false,

      detailDialogTitle: "",

      detailLoading: false,

      detailTableData: [],

      detailSummaryTotals: null,
    };
  },

  created() {
    this.loadFilterOptions();

    this.loadData();
  },

  methods: {
    loadFilterOptions() {
      this.contractNameOptions = [];

      const pageSize = 200;

      const maxPages = 100;

      const loadAllPages = async () => {
        const all = [];

        for (let p = 1; p <= maxPages; p++) {
          try {
            const response = await api.statistics.fetchSalesContractsFilterPage(
              { page: p, size: pageSize }
            );

            if (!response.data || !response.data.success) break;

            const { list: content, total } =
              api.statistics.pickContractFilterPage(response.data);

            all.push(...content);

            if (content.length < pageSize) break;

            if (total != null && all.length >= total) break;
          } catch (e) {
            break;
          }
        }

        return all;
      };

      loadAllPages()
        .then((content) => {
          const names = new Set();

          content.forEach((item) => {
            if (item.contractName) {
              names.add(String(item.contractName).trim());
            }
          });

          this.contractNameOptions = [...names].filter(Boolean).sort();
        })

        .catch(() => {});
    },

    handleSearch() {
      this.pagination.currentPage = 1;

      this.loadData();
    },

    handleReset() {
      this.dateRange = [];

      this.selectedContractNames = [];

      this.productNameKeyword = "";

      this.pagination.currentPage = 1;

      this.loadData();
    },

    handleExport() {
      this.exportLoading = true;

      const params = {};

      if (this.dateRange && this.dateRange.length === 2) {
        params.startDate = this.dateRange[0];

        params.endDate = this.dateRange[1];
      }

      if (this.selectedContractNames && this.selectedContractNames.length > 0) {
        params.contractNames = this.selectedContractNames;
      }

      const kw = (this.productNameKeyword || "").trim();

      if (kw) {
        params.productName = kw;
      }

      api.statistics
        .exportProductSettlementSalesStatistics(params)

        .then((response) => {
          const blob = new Blob([response.data], {
            type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
          });

          const url = window.URL.createObjectURL(blob);

          const link = document.createElement("a");

          link.href = url;

          const contentDisposition = response.headers["content-disposition"];

          let fileName = "产品明细销售统计.xlsx";

          if (contentDisposition) {
            const match = contentDisposition.match(/filename\*?=([^;]+)/i);

            if (match) {
              fileName = decodeURIComponent(
                match[1].replace(/^UTF-8''/, "").trim()
              );
            }
          }

          link.download = fileName;

          document.body.appendChild(link);

          link.click();

          document.body.removeChild(link);

          window.URL.revokeObjectURL(url);

          this.$message.success("导出成功");
        })

        .catch((err) => {
          this.$message.error(err.response?.data?.message || "导出失败");
        })

        .finally(() => {
          this.exportLoading = false;
        });
    },

    handleSizeChange(val) {
      this.pagination.pageSize = val;

      this.pagination.currentPage = 1;

      this.loadData();
    },

    handleCurrentChange(val) {
      this.pagination.currentPage = val;

      this.loadData();
    },

    formatAmount(amount) {
      if (amount === undefined || amount === null) return "0.00";

      return Number(amount)
        .toFixed(2)
        .replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    },

    formatQuantity(q) {
      if (q === undefined || q === null) return "0.0000";

      return Number(q)
        .toFixed(4)
        .replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    },

    summaryMethod() {
      const t = this.summaryTotals || {};

      const fmtAmt = (k) => this.formatAmount(t[k] != null ? t[k] : 0);

      const fmtQty = (k) => this.formatQuantity(t[k] != null ? t[k] : 0);

      return [
        "合计",
        "",
        "",
        fmtQty("salesQuantitySum"),
        fmtAmt("salesAmountSum"),
        "",
        "",
        "",
      ];
    },

    detailSummaryMethod() {
      const t = this.detailSummaryTotals || {};

      const fmtAmt = (k) => this.formatAmount(t[k] != null ? t[k] : 0);

      const fmtQty = (k) => this.formatQuantity(t[k] != null ? t[k] : 0);

      return [
        "合计",
        "",
        fmtQty("salesQuantitySum"),
        fmtAmt("salesAmountSum"),
        "",
        "",
      ];
    },

    aggregateDetailTotals(rows) {
      let qty = 0;

      let amt = 0;

      (rows || []).forEach((r) => {
        qty += Number(r.salesQuantity != null ? r.salesQuantity : 0);

        amt += Number(r.salesAmount != null ? r.salesAmount : 0);
      });

      return {
        salesQuantitySum: qty,

        salesAmountSum: amt,
      };
    },

    openDetailDialog(row) {
      const cid = row.contractId;

      if (cid === undefined || cid === null) {
        this.$message.warning("缺少合同信息，无法加载明细");

        return;
      }

      const pname = row.productName != null ? String(row.productName) : "";

      const ctitle = row.contractName != null ? String(row.contractName) : "";

      this.detailDialogTitle = `规格明细 — ${ctitle} / ${
        pname || "（未命名产品）"
      }`;

      this.detailDialogVisible = true;

      this.detailLoading = true;

      this.detailTableData = [];

      this.detailSummaryTotals = null;

      const params = {
        contractId: cid,

        productNameExact: pname,
      };

      if (this.dateRange && this.dateRange.length === 2) {
        params.startDate = this.dateRange[0];

        params.endDate = this.dateRange[1];
      }

      if (this.selectedContractNames && this.selectedContractNames.length > 0) {
        params.contractNames = this.selectedContractNames;
      }

      const kw = (this.productNameKeyword || "").trim();

      if (kw) {
        params.productName = kw;
      }

      api.statistics

        .getProductSettlementSalesStatisticsDetailLines(params)

        .then((response) => {
          if (response.data && response.data.success) {
            const list = response.data.data || [];

            this.detailTableData = list;

            this.detailSummaryTotals = this.aggregateDetailTotals(list);
          } else {
            this.detailTableData = [];

            this.$message.error(response.data?.message || "加载明细失败");
          }
        })

        .catch((err) => {
          this.detailTableData = [];

          this.$message.error(err.response?.data?.message || "加载明细失败");
        })

        .finally(() => {
          this.detailLoading = false;
        });
    },

    onDetailDialogClosed() {
      this.detailTableData = [];

      this.detailSummaryTotals = null;

      this.detailDialogTitle = "";
    },

    loadData() {
      this.loading = true;

      const params = {
        page: this.pagination.currentPage - 1,

        size: this.pagination.pageSize,
      };

      if (this.dateRange && this.dateRange.length === 2) {
        params.startDate = this.dateRange[0];

        params.endDate = this.dateRange[1];
      }

      if (this.selectedContractNames && this.selectedContractNames.length > 0) {
        params.contractNames = this.selectedContractNames;
      }

      const kw = (this.productNameKeyword || "").trim();

      if (kw) {
        params.productName = kw;
      }

      api.statistics
        .getProductSettlementSalesStatistics(params)

        .then((response) => {
          if (response.data && response.data.success) {
            const data = response.data.data || {};

            this.tableData = data.content || [];

            this.pagination.total = data.totalElements || 0;

            this.summaryTotals = data.totals || null;
          } else {
            this.tableData = [];

            this.summaryTotals = null;

            this.$message.error(response.data?.message || "查询失败");
          }
        })

        .catch((err) => {
          this.tableData = [];

          this.summaryTotals = null;

          this.$message.error(err.response?.data?.message || "查询失败");
        })

        .finally(() => {
          this.loading = false;
        });
    },
  },
};
</script>

<style lang="scss" scoped>
.statistics-container {
  padding: 20px;
}

.page-header {
  margin-bottom: 20px;
}

.header-title {
  display: flex;

  align-items: center;

  font-size: 18px;

  font-weight: bold;

  color: #303133;
}

.title-mark {
  width: 4px;

  height: 18px;

  background: #409eff;

  margin-right: 10px;
}

.search-area {
  display: flex;

  gap: 10px;

  align-items: center;

  flex-wrap: wrap;

  margin-bottom: 20px;
}

.search-input.date-picker {
  width: 300px;
}

.select-multi {
  min-width: 200px;

  max-width: 320px;
}

.product-name-input {
  width: 200px;
}

.table-area {
  margin-bottom: 20px;
}

.pagination-container {
  display: flex;

  justify-content: flex-end;

  margin-top: 16px;
}

::v-deep .el-table th {
  background-color: #f5f7fa !important;

  color: #606266 !important;

  font-weight: 600;
}

::v-deep .el-table__footer-wrapper tbody td {
  background-color: #fafafa !important;

  font-weight: 600;
}
</style>
